import {FC, ReactNode, useEffect, useState} from "react";
import {DepartmentFromProps} from "../types";
import {Form, Input, Spin, Switch, UploadFile} from "antd";
import * as BUCKETS from "../../../../../../enums/buckets"
import "./style.less"
import Uploader from "../../../../../../components/uploader/Uploader";
import {useUploadController} from "../../../../../../controllers/upload-controller";
import {getImageLink} from "../../../../../../helpers/mainHelpers";
import TextEditor from "../../../../../../components/text-editor/TextEditor";

export const DepartmentFrom: FC<DepartmentFromProps> = (props) => {
  const {form, createDepartment, selectedDepartment, isLoading, updateDepartment} = props
  const [uploadImages, setUploadImages] = useState<UploadFile[]>([])
  const [mainImageId, setMainImageId] = useState<string | undefined>(undefined)
  const [previewImage, setPreviewImage] = useState<UploadFile[]>([])
  const {isFilesLoading, fetchFilesHandler, currentFiles} = useUploadController()
  const isDataLoading = isFilesLoading || isLoading
  const [aboutDepartment, setAboutDepartment] = useState("")


  useEffect(() => {
    if (selectedDepartment) {
      form.setFieldsValue(selectedDepartment)
      setMainImageId(selectedDepartment.mainImage)
      fetchFilesHandler({fileIds: selectedDepartment.images, bucketId: BUCKETS.MAIN})
      // Set preview image data
      const currentPreviewImage = {
        uid: selectedDepartment.previewImage,
        name: "image",
        url: getImageLink({imageId: selectedDepartment.previewImage, bucketId: BUCKETS.MAIN}),
        response: {$id: selectedDepartment.previewImage}
      }
      setPreviewImage([currentPreviewImage])

    } else {
      form.resetFields()
      setMainImageId(undefined)
      setUploadImages([])
    }
  }, [selectedDepartment])

  useEffect(() => {
    if (currentFiles.length) {
      const files = currentFiles.map((file) => {
        return {
          uid: file.$id,
          name: file.name,
          url: getImageLink({imageId: file.$id, bucketId: BUCKETS.MAIN}),
          response: {$id: file.$id}
        }
      })
      setUploadImages(files)
    }
  }, [
    currentFiles
  ])

  const formSubmitHandler = async (formData: { name: string, about: string, departmentContainOffices: boolean, patientInfoVisible: boolean }) => {
    const departmentData = {
      name: formData.name,
      about: aboutDepartment,
      images: uploadImages.map((image) => image.response?.$id) as unknown as string[],
      mainImage: mainImageId || "",
      previewImage: previewImage[0]?.response?.$id || "",
      departmentContainOffices: formData.departmentContainOffices,
      patientInfoVisible: formData.patientInfoVisible
    }
    if (!selectedDepartment) {
      await createDepartment(departmentData)
    } else {
      await updateDepartment({...departmentData, $id: selectedDepartment.$id})
    }

  }


  // DRY check
  const onMainImageSwitchChange = (props: { fileId: string, value: boolean }) => {
    const {fileId, value} = props
    if (!value) {
      setMainImageId(undefined)
    } else {
      setMainImageId(fileId)
    }
  }

  const customUploadItemRender = (originNode: ReactNode,
                                  file: UploadFile,
                                  fileList: UploadFile[],
                                  actions: {
                                    download: () => void;
                                    preview: () => void;
                                    remove: () => void;
                                  }
  ) => {
    return <span> {originNode} <Switch checked={file.response?.$id === mainImageId} onChange={(checked, event) => {
      onMainImageSwitchChange({fileId: file.response.$id, value: checked})

    }} size="small" checkedChildren="Головне" unCheckedChildren="Додаткове"/></span>
  }


  return (
    <Spin spinning={isDataLoading}>
      <Form form={form} layout="vertical" className="department_form" onFinish={formSubmitHandler}>
        <Form.Item name="name" label="Назва">
          <Input/>
        </Form.Item>
        <Form.Item name="about" label="Основна інформація">
          <TextEditor value={selectedDepartment?.about || ""} setValue={setAboutDepartment}/>
        </Form.Item>
        <Form.Item initialValue={false} name="departmentContainOffices" label="У відділенні присутні кабінети">
          <Switch/>
        </Form.Item>
        <Form.Item initialValue={false} name="patientInfoVisible" label="Показувати інформацію для пацієнтів">
          <Switch/>
        </Form.Item>
        <Form.Item label="Зображення попереднього перегляду">
          <Uploader maxCount={1} bucketId={BUCKETS.MAIN} files={previewImage} setFiles={setPreviewImage}/>
        </Form.Item>
        <Form.Item label="Галерея" name="images">
          <Uploader files={uploadImages} setFiles={setUploadImages} customUploadItemRender={customUploadItemRender}
                    bucketId={BUCKETS.MAIN}/>
        </Form.Item>
      </Form>
    </Spin>
  )
}
export default DepartmentFrom